export enum ShippingLabelStep {
  None = 'None',
  Validation = 'Validation',
  OrderWithoutAutomatizaion = 'OrderWithoutAutomatizaion',
  OrderLabelPrint = 'OrderLabelPrint',
  Close = 'Close',
}
